"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMEventSender = void 0;
const constants_1 = require("../constants");
const EventSenderBase_1 = require("./EventSenderBase");
class DOMEventSender extends EventSenderBase_1.EventSenderBase {
    get url() {
        return constants_1.LINK_AND_BUTTONS_EVENT_REQUEST_URL;
    }
}
exports.DOMEventSender = DOMEventSender;
